import { TopNav, PageShell, TailPageCTA, BackCoverFooter } from "./components/brand-scaffold";
import { HomepageHero } from "@/design-system/patterns/homepage-hero";
import { HomepageWhatIsHotline } from "@/design-system/patterns/homepage-what-is-hotline";
import { HomepageCallFlow } from "@/design-system/patterns/homepage-call-flow";
import { HomepageRealStatus } from "@/design-system/patterns/homepage-real-status";
import { HomepagePathways } from "@/design-system/patterns/homepage-pathways";
import { HomepageWhyNotJust } from "@/design-system/patterns/homepage-why-not-just";
import { HomepageMarketplacePreview } from "@/design-system/patterns/homepage-marketplace-preview";
import { HomepageOpenSource } from "@/design-system/patterns/homepage-open-source";
import { HomepageFaq } from "@/design-system/patterns/homepage-faq";
import { siteHeaderActions, siteNavItems } from "./content";

export default function App() {
  return (
    <PageShell>
      <TopNav navItems={siteNavItems} actionItems={siteHeaderActions} homeHref="/" />

      <main className="relative z-10 w-full overflow-hidden">
        <HomepageHero />
        <HomepageWhatIsHotline />
        <HomepageCallFlow />
        <HomepageRealStatus />
        <HomepagePathways />
        <HomepageWhyNotJust />
        <HomepageMarketplacePreview />
        <HomepageOpenSource />
        <HomepageFaq />
        <TailPageCTA />
      </main>

      <BackCoverFooter />
    </PageShell>
  );
}
